@let itemClass = isMobile() ? "mobile-menu-item" : "";
@let hostClass = isMobile() ? "mobile-menu-item" : "";
@if (!isMobile()) {
  <div class="crowndesk-menu" [class.user-menu-open]="userMenuOpen()">
    @let toggleLabel = (collapsed() ? "PIN_MENU" : "COLLAPSE_MENU") | translate | capitalize;
    <button
      type="button"
      class="crowndesk-menu__toggle"
      kendoTooltip
      position="right"
      [offset]="12"
      tooltipClass="crowndesk-menu__tooltip"
      (click)="toggleCollapsed()"
      [attr.aria-label]="toggleLabel"
      [attr.aria-expanded]="!collapsed()"
      [title]="toggleLabel"
    >
      <i class="fs-20" [class]="collapsed() ? 'rc-icon-double-chevron-right' : 'rc-icon-double-chevron-left'"></i>
    </button>
    @for (item of menu(); track item) {
      @let activeDropdown = isDropdownActive(item);

      @if (item.items) {
        <rc-menu-dropdown [hostClass]="hostClass" [itemClass]="itemClass" [dropdownMenu]="item"
                          [defaultOpen]="activeDropdown"></rc-menu-dropdown>
      } @else {
        <!--    @if (this.opened) {-->
        <a
          class="menu-item"
          [ngClass]="itemClass"
          [routerLink]="[item.url]"
          [rcNavigate]="item.url"
          [queryParams]="item.params"
          [routerLinkActive]="['active']"
          kendoTooltip
          [routerLinkActiveOptions]="{
        paths: 'subset',
        fragment: 'ignored',
        matrixParams: 'ignored',
        queryParams: 'ignored',
      }">
        <span class="fs-14 fw-400">
          <i [class]="item.icon" class="fs-24"></i>
          <span class="item-text">{{ item.text | translate | capitalize }}</span>
        </span>
        </a>
      }
    }
    <div class="d-flex w-100 border-all-1 border-color-base-white w-100 pt-8 pb-8 mt-auto user-settings">
      <button
        kendoPopoverAnchor
        #userMenuAnchor="kendoPopoverAnchor"
        [popover]="myPopover"
        kendoButton
        class="d-flex gap-8 w-100 bgc-transparent fc-base-white justify-content-between"
      >
      <span class="d-flex align-items-center w-100">
        <i class="rc-icon-user fs-24 user-settings__icon"></i>
        <span class="d-flex flex-column  w-100 user-settings__names">
            <span class="item-text">{{ user().companyName | capitalize }}</span>
            <span class="item-text user-settings__employee">{{ user().fullName }}</span>
        </span>
      </span>
        <span class="pe-16 user-settings__chevron"><i class="rc-icon-chevron-down"></i></span>
      </button>

      <kendo-popover #myPopover position="top" (show)="userMenuOpen.set(true); repositionUserMenu()" (hide)="userMenuOpen.set(false)" (hidden)="userMenuOpen.set(false)">
        <ng-template kendoPopoverBodyTemplate>
          <div class="d-flex flex-column">
            <ng-container *ngTemplateOutlet="userMenuOptions"></ng-container>
          </div>
        </ng-template>
      </kendo-popover>
      <!--    <rc-menu-dropdown [hostClass]="'border-all-1 border-color-base-white w-100 pt-8 pb-8 mt-auto position-relative'"  itemClass='top-100 position-absolute bgc-base-white fc-primary-500' [dropdownMenu]="userMenuItem()" [defaultOpen]="false"></rc-menu-dropdown>-->
    </div>
    <!--}-->
  </div>
} @else {
  <div class="crowndesk-mobile-menu d-flex gap-8 align-items-center">
  <div
    class="d-flex flex-column h-inherit w-inherit"
    kendoPopoverAnchor
    rcClickOutside
    (clickOutside)="mobileUserMenu.hide()"
    #mobileUserMenu="kendoPopoverAnchor"
    [popover]="mobileUserPopover"
    [showOn]="'none'"
    [tabIndex]="0"
    (click)="mobileUserMenu.toggle()"
  >
    <button
      kendoButton
      class="user-button k-button-clear notifications-button h-inherit w-inherit p-0"
      [attr.aria-label]="'USER_SETTINGS' | translate | capitalize"
    >
      <i class="rc-icon-user fc-neutral-600 fs-24"></i>
    </button>

    <kendo-popover #mobileUserPopover [animation]="false" [callout]="false" position="bottom">
      <ng-template kendoPopoverBodyTemplate>
        <div class="rc-popover rc-popover-skin rc-popover--no-callout mobile-menu-popover mobile-user-menu d-flex flex-column gap-8">
          <div class="d-flex flex-column px-16 pt-8 pb-8 border-bottom-1 border-color-neutral-200">
            <span class="item-text fw-600">{{ user().companyName | capitalize }}</span>
            <span class="item-text fc-neutral-600">{{ user().fullName }}</span>
          </div>
          <ng-container *ngTemplateOutlet="userMenuOptions"></ng-container>
        </div>
      </ng-template>
    </kendo-popover>
  </div>
  <div
    class="d-flex flex-column h-inherit w-inherit"
    kendoPopoverAnchor
    rcClickOutside
    (clickOutside)="userMenuMobile.hide()"
    #userMenuMobile="kendoPopoverAnchor"
    [popover]="mobileMenuPopover"
    [showOn]="'none'"
    [tabIndex]="0"
    (click)="userMenuMobile.toggle()"
  >
    <button
      kendoButton
      #hamburgerBtn
      class="hamburger-button k-button-clear notifications-button h-inherit w-inherit p-0"
    >
      <i class="rc-icon-hamburger-menu fc-neutral-600 fs-24"></i>
    </button>

    <kendo-popover #mobileMenuPopover
                   [animation]="false"
                   [callout]="false"
                   class="overflow-y-auto"
                   position="bottom">
      <ng-template kendoPopoverBodyTemplate>
        <div class="rc-popover rc-popover-skin rc-popover--no-callout mobile-menu-popover d-flex flex-column gap-8">
          @for (item of menu(); track item) {
            @let activeDropdown = isDropdownActive(item);

            @if (item.items) {
              <rc-menu-dropdown [hostClass]="hostClass" [itemClass]="itemClass" [dropdownMenu]="item"
                                [defaultOpen]="activeDropdown" (linkClicked)="closeMobileMenu()"></rc-menu-dropdown>
            } @else {
              <!--    @if (this.opened) {-->
              <a
                class="menu-item"
                [ngClass]="itemClass"
                [routerLink]="[item.url]"
                [queryParams]="item.params"
                [routerLinkActive]="['active']"
                kendoTooltip
                (click)="closeMobileMenu()"
                [routerLinkActiveOptions]="{
                paths: 'subset',
                fragment: 'ignored',
                matrixParams: 'ignored',
                queryParams: 'ignored',
              }">
        <span class="fs-14 fw-400">
          <i [class]="item.icon" class="fs-24"></i>
          <span class="item-text">{{ item.text | translate | capitalize }}</span>
        </span>
              </a>
            }
          }
        </div>
      </ng-template>
    </kendo-popover>
  </div>
  </div>
}

<!-- The options of the user menu: in the side menu on desktop, behind the user icon on mobile -->
<ng-template #userMenuOptions>
  <button
    kendoButton
    themeColor="primary"
    class="w-100 justify-content-start bgc-transparent fc-base-black justify-content-start hfc-primary-500"
    iconClass="rc-icon-settings"
    routerLink="/users/settings"
    (click)="closeUserMenus()"
  >
    {{ "USER_SETTINGS" | translate | capitalize }}
  </button>
  <button
    kendoButton
    (click)="logout()"
    themeColor="primary"
    class="w-100 text-align-left bgc-transparent fc-base-black justify-content-start hfc-primary-500"
    iconClass="rc-icon-logout"
  >
    <!-- While a Royal Crown employee is logged in as a client employee, this only stops that -->
    {{ (isImpersonating() ? "STOP_IMPERSONATION" : "LOGOUT") | translate | capitalize }}
  </button>
</ng-template>
